module.exports = __webpack_public_path__ + "img/7.10ef2d38.png";